import React, { useState } from 'react';
import DragAndDrop from 'components/DragAndDrop';
import './Sped.scss';
import PageHeader from 'components/PageHeader';
import { Button, Icon, Header } from 'semantic-ui-react';
import request from 'services/http';
import { tap, finalize } from 'rxjs/operators';
import { download } from '@rededompedro/utils';

export default function Sped() {

    const [loading, setLoading] = useState(false);
    const [disabled, setDisabled] = useState(true);
    const [file, setFile] = useState(null);

    function handleFile(file) {
        setLoading(true);
        const formData = new FormData();
        formData.append('file', file);
        request({
            url: '/sped/txt-processamento',
            method: 'POST',
            body: formData,
        })
        .pipe(
            tap(({ response }) => {
                setFile(response);
            }),
            finalize(() => {
                setLoading(false);
                setDisabled(false);
            })
        )
        .subscribe()
    }

    function downloadFile() {
        if (file) {
            const blob = new Blob([new Uint8Array(file.generatedFile.data)], { type: 'text/plain' });
            download(blob, file.filename);
        }
    }

    return (
        <div className='page-content'>
            <PageHeader />
            <div id="sped" className="subcontent">
                <Header as="h3" className='mt-4'>
                    <Icon.Group size="big">
                        <Icon name="tasks" className="primary-color" />
                    </Icon.Group>
                    <Header.Content className="primary-color">
                        Sped Export
                        <Header.Subheader className="secondary-color">
                            <strong>F100 e Participantes</strong>
                        </Header.Subheader>
                    </Header.Content>
                </Header>
                <DragAndDrop height={200} width={200} onDrop={handleFile} />
                <Button
                    onClick={downloadFile}
                    disabled={disabled || loading}
                    loading={loading}
                    size='large'
                    color='green'
                    icon='arrow down'
                    content='Baixar'
                    style={{
                        marginTop: 20,
                    }}
                />
            </div>
        </div>
    )
}
